import axios from 'axios'
import delay from 'delay'

const CommandStatus = {
    Queued: 0,
    Running: 1,
    Succeeded : 2,
    Failed: 3,
};

const Commands = {

    async resolveCommand(ticket) {
        while (true) {
            var cmd = (await axios.get('/SoftPro.Commands/Commands/' + ticket.key)).data;
            if (cmd.status == CommandStatus.Succeeded) {
                return cmd.result ? JSON.parse(cmd.result) : null;
            }
            else if (cmd.status == CommandStatus.Failed) {
                throw cmd.result;
            } else {
                await delay(1000);
            }
        }
    }    
}

export { Commands, CommandStatus };
